import { LOCATION_CHANGE } from "connected-react-router";
import actions from "./partyActions";
import hostActions from "../VotifyHost/hostActions";

const initialState = {
  isLookingForParty: false,
  hasAckParty: false,
  hasFoundParty: false,
  isLoadingParty: false,
  socketTimeoutMs: 0,
  partyUrl: "",
  partyId: "",
  partyName: "",
  participants: [],
};

export const STATE_KEY = "party";

const partyReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.LOAD_PARTY:
      return {
        ...state,
        partyUserProfile: action.payload.userProfile,
        participants: action.payload.participants,
      };
    case actions.FOUND_PARTY:
      return {
        ...state,
        hasFoundParty: true,
        partyId: action.payload.id,
        partyName: action.payload.name,
        partyUrl: action.payload.url,
      };
    case actions.CREATE_PARTY:
      return {
        ...state,
        partyId: action.payload.id,
        partyName: action.payload.name,
        partyUrl: action.payload.url,
        hasFoundParty: true,
      };
    case actions.LEAVE_PARTY:
      return {
        ...state,
        partyId: "",
        partyName: "",
        partyUrl: "",
        isLookingForParty: false,
        hasFoundParty: false,
      };
    case actions.SOCKET_ACK_PARTY:
      return {
        ...state,
        socketTimeoutMs: 0,
        hasAckParty: true,
      };
    case actions.SOCKET_NOT_ACK_PARTY:
      return {
        ...state,
        socketTimeoutMs: 0,
        hasAckParty: false,
      };
    case actions.SOCKET_LOST_CONNECTION:
      return {
        ...state,
        hasAckParty: false,
      };
    case actions.START_GET_PARTY_REQUEST:
      return {
        ...state,
        isLoadingParty: true,
        isLookingForParty: true,
      };
    case actions.START_CREATE_PARTY_REQUEST:
      return {
        ...state,
        isLookingForParty: true,
        isExistingParty: true,
      };
    case actions.END_CREATE_PARTY_REQUEST:
      return {
        ...state,
        isLoadingParty: false,
      };
    case actions.END_GET_PARTY_REQUEST:
      return {
        ...state,
        isLoadingParty: false,
      };
    case LOCATION_CHANGE:
      return state;
    case hostActions.SUCCESS_SET_PARTY_NAME_REQUEST:
      return {
        ...state,
        partyName: action.payload.name,
        partyUrl: action.payload.url,
      };
    default:
      return state;
  }
};

export default partyReducer;
